import { RowMiddle } from 'layout/Components/Row'
import { Trans } from 'react-i18next'
import styled from 'styled-components'
import Text from 'UIKit/Text'
import { GameFilterOptionType } from '../config'

const GameFilterOptionItem: React.FC<{ item: GameFilterOptionType }> = ({ item }) => {
  return (
    <RowMiddle px="4px">
      <StyledText fontSize={['14px', , '12px']} color="textSubtle" fontWeight={400}>
        <Trans>{item.value}</Trans>
      </StyledText>
    </RowMiddle>
  )
}

const StyledText = styled(Text)`
  color: ${({ theme }) => theme.colors.text_primary};

  ${({ theme }) => theme.mediaQueries.sm} {
    color: ${({ theme }) => theme.colors.textSubtle};
  }
`

export default GameFilterOptionItem
